function normalizeCourierLabel(value) {
  if (value == null) return null;
  const trimmed = String(value).trim();
  if (!trimmed) return null;

  const lower = trimmed.toLowerCase().replace(/\s+/g, "");
  if (lower === "bosta") return "Bosta";
  if (lower === "shipblu") return "ShipBlu";
  if (lower === "fincart") return "Fincart";
  if (lower === "blink") return "Blink";

  return trimmed;
}

function courierFromOrderSignals(order) {
  // Explicit courier on the order wins over partner shipping config.
  const explicit = normalizeCourierLabel(order?.courier);
  if (explicit) {
    if (explicit === "Fincart" && order?.fincartCourier) {
      return order.fincartCourier;
    }
    return explicit;
  }

  // Infer from order-owned tracking / integration IDs.
  if (order?.bostaTrackingId) {
    return "Bosta";
  }
  if (order?.blinkTrackingId || order?.blinkId) {
    return "Blink";
  }
  if (order?.shipbluTrackingId) {
    return "ShipBlu";
  }
  if (order?.fincartId || order?.courierTrackingId) {
    return order?.fincartCourier || "Fincart";
  }

  return null;
}

export function getOrderTrackingId(order) {
  return order?.blinkTrackingId || order?.courierTrackingId || order?.shipbluTrackingId || order?.bostaTrackingId || null;
}

export function getOrderCourierLabel(order, vendor) {
  const fromOrder = courierFromOrderSignals(order);
  if (fromOrder) {
    return fromOrder;
  }

  // Only fall back to the partner's configured service when the order has
  // no courier / tracking signal of its own yet (e.g. not shipped).
  const shippingService = normalizeCourierLabel(
    vendor?.shippingService || order?.vendor?.shippingService
  );

  if (shippingService === "Fincart") {
    return order?.fincartCourier || "Fincart";
  }

  return shippingService;
}

export function getOrderShippingServiceLabel(order, vendor) {
  return (
    courierFromOrderSignals(order)
    || normalizeCourierLabel(vendor?.shippingService || order?.vendor?.shippingService)
    || null
  );
}
